import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpDescr } from '../core/op-descr'
import { OpEnumObject } from './op-enum-object'


export class OpDashboardGroup {
    //Properties
    public idGroup: number
    public idDashboard: number
    public name: string
    public borderVisible: boolean
    public width: number
    public height: number
    public refreshPeriod: number
    public module: Enums.SimaxModuleName
    public isTemplate: boolean
    public opState: Enums.OpChangeState
    public indexNbr: number
    public column: number
    //Properties end

    //NavigationProperties
    public descr: OpDescr
    //NavigationProperties end

    constructor(opObj: any) {
        if (opObj) {
            this.idGroup = opObj.IdGroup
            this.idDashboard = opObj.IdDashboard
            this.name = opObj.Name
            this.descr = opObj.Descr
            this.borderVisible = opObj.BorderVisible
            this.width = opObj.Width
            this.height = opObj.Height
            this.refreshPeriod = opObj.RefreshPeriod
            this.module = opObj.Module
            this.isTemplate = opObj.IsTemplate
            this.opState = opObj.OpState
            this.indexNbr = opObj.IndexNbr
            this.column = opObj.Column

            this.descr = new OpDescr(opObj.Descr)
        }
    }
}